import React from 'react';
import { Card, TextContainer, TextStyle } from '@shopify/polaris';

function DepositProcessor({ processor }) {
  return (
    <Card.Section title="Processor" sectioned>
      <TextContainer>
        {processor ? (
          <p>{processor}</p>
        ) : (
          <TextStyle variation="subdued">No processor</TextStyle>
        )}
      </TextContainer>
    </Card.Section>
  );
}

export default DepositProcessor;
